import ModelButton from 'components/ModelButton';
import { ITableModel } from 'components/Table/interface';

import iconRemove from 'img/icon-remove-legal-document.svg';

const removeDocumentActionButton = (functionDeleteDocument: any, title?: string, size?: number) =>
  ModelButton(
    title || '',
    iconRemove,
    (data: any) => functionDeleteDocument(data),
    "",
    size
  );

const labelTypeDocument = {
  label: 'Tipo do documento',
  key: 'realNameTypeDocument',
  noFilter: true,
  size: 280,
  maxSize: 280
};

const labelNameDocument = {
  label: 'Nome do documento',
  key: 'nameDocument',
  noFilter: true
};

const legalDocumentModelComplete: Array<ITableModel> = [
  labelTypeDocument,
  labelNameDocument
];

const legalDocumentModelCompleteButton = (functionDeleteDocument: any) => {
  const model: Array<ITableModel> = [
    ...legalDocumentModelComplete,
    removeDocumentActionButton(functionDeleteDocument, "", 80)
  ];

  return model;
};


export {
  legalDocumentModelComplete,
  legalDocumentModelCompleteButton
};
